// Generated by purs version 0.15.15
var contextPreviewConsoleProgramName = "ContextPreviewConsoleProgram";
export {
    contextPreviewConsoleProgramName
};
//# sourceMappingURL=index.js.map
